import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const PagerDutyShape = {
  service_key: Yup.string().label("Integration key").min(32).max(32).required(),
  autoresolve: Yup.boolean().label("Auto-resolve Incident").optional(),
};

export interface PagerDutyInput {
  service_key: string;
  autoresolve?: boolean;
}

yupResolver<PagerDutyInput>(Yup.object().shape(PagerDutyShape));
